        <div class="l-flex l-wrap t-row--med">
          <div *ngFor="let word of phraseWords; let i=index">
            <checkbox-wrap class="checkbox" [label]="word.text">
              <input
                type="checkbox"
                [value]="word"
                (change)="onCheckboxChange($event, word)"
                 [checked]="selectedWords.includes(word)"
                 [disabled]="disabled || i==0"
              />
            </checkbox-wrap>
            &nbsp;&nbsp;
          </div>
        </div>
          <ng-container *ngFor="let phrase of newPhrases; let i=index;">
            <div class="phrase">
                <formatted-phrase [phraseWords]="phrase.phrase_words"></formatted-phrase>
                <ng-container *ngIf="i != 0">
                    <a style="margin-left: 20px;" (click)="overlay.toggle($event);" [ngClass]="{ 'disabled': disabled }"
                    >{{ phrase.phrase_content_type }}
                    </a>
                      <p-popover #overlay [dismissable]="true" appendTo="body" baseZIndex="99999">
                          <ul class="menu-list">
                            <li *ngFor="let item of contentTypeOptions" [class.disabled]="disabled" (click)="changeType(phrase, item)"
                            [ngClass]="{ 'selected': item.label === phrase.phrase_content_type }">
                              {{ item.label }}
                            </li>
                          </ul>
                      </p-popover>
                    </ng-container>
            </div>
        </ng-container>